const p = (r) => "File" in window && r instanceof File, y = () => {
  const r = { current: [] };
  return {
    cancel: () => r.current = [],
    append: (u) => r.current.push(u),
    requests: r,
    type: Symbol("requestGroup")
  };
}, h = {
  requestCount: 0
}, w = async (r, u) => {
  h.requestCount += 1;
  const o = h.requestCount, e = { method: "get", debug: !1, ...u }, c = Symbol("request");
  if (e.group && e.group.append(c), e.data)
    try {
      e.body = JSON.stringify(e.data), e.headers = {
        "Content-Type": "application/json",
        ...e.headers
      };
    } catch {
      throw new Error("request: Could not stringify data");
    }
  else {
    if (e.data)
      throw new Error("request: Data must only be provided to post requests");
    if (e.form) {
      const s = new FormData();
      Object.entries(e.form).forEach(([n, t]) => {
        if (t !== void 0) {
          if (t === null) {
            s.set(n, "");
            return;
          }
          if (typeof t == "string" || typeof t == "number") {
            s.set(n, `${t}`);
            return;
          }
          if (p(t)) {
            s.set(n, t);
            return;
          }
          if (Array.isArray(t) && t.length && t.every((a) => p(a))) {
            t.forEach((a) => s.append(`${n}[]`, a));
            return;
          }
          if (typeof t == "object" && t !== null || Array.isArray(t)) {
            try {
              const a = JSON.stringify(t);
              s.set(n, a);
            } catch {
            }
            return;
          }
        }
      }), e.body = s;
    }
  }
  const d = e.params ? new URLSearchParams(e.params).toString() : "", l = d ? `${r}?${d}` : r;
  e.debug && console.log(`REQ [${o}]:`, l, e);
  try {
    const s = await fetch(l, e), n = s.ok || s.status >= 200 && s.status <= 299, t = s.headers.get("content-type"), i = await ((t == null ? void 0 : t.includes("application/json")) ? s.json() : s.text()).catch(() => null), f = e.group ? !e.group.requests.current.includes(c) : !1;
    if (e.throwCanceled && f)
      throw new Error("request: Request canceled");
    return n && !f ? (e.debug && console.log(`RES [${o}]:`, {
      success: !0,
      data: i,
      canceled: !1,
      network: !1
    }), {
      success: !0,
      data: i,
      canceled: !1,
      network: !1
    }) : (e.debug && console.log(`RES [${o}]:`, {
      success: !1,
      data: i,
      canceled: f,
      network: !1
    }), {
      success: !1,
      data: i,
      canceled: f,
      network: !1
    });
  } catch (s) {
    if (console.error(s), e.throwNetwork)
      throw s;
    return e.debug && console.log(`RES [${o}]:`, {
      success: !1,
      data: { code: "FETCH_ERROR" },
      canceled: !1,
      network: !0
    }), { success: !1, data: { code: "FETCH_ERROR" }, canceled: !1, network: !0 };
  }
}, g = ["get", "post", "put", "delete", "patch"], q = (r) => {
  const u = r.bind({}), o = (e, c) => {
    try {
      return u(e, c);
    } catch {
      return Promise.resolve({
        success: !1,
        data: { code: "FETCH_ERROR" },
        canceled: !1,
        network: !0
      });
    }
  };
  return g.forEach(
    (e) => o[e] = (c, d) => o(c, { ...d, method: e })
  ), o;
}, R = q(w);
export {
  q as createFetcher,
  y as createRequestGroup,
  R as request
};
